<template>
	<div>
		<!-- <p class="second-p">{{episodes[0].title}}</p> -->
		<div class="second-div">
			<p
				class="second-div-p"
				v-for="(item, index) in episodes"
				:key="index"
				@click="toReads(item.id,index)"
			>
				{{item.title}}
				<i v-show="[1, 3, 7, 8, 9, 10, 11, 26, 21, 23, 24, 27, 30,34].indexOf(index+1)!=-1"></i>
				<!-- <img src="../img/read.png" alt class="second-img" v-if="item.bid!=1" /> -->
			</p>
		</div>
		<!-- <div class="second-div1" v-if="episodes.length>3">
			<p>查看全部目录</p>
			<img src="../img/xiala.png" alt />
		</div>-->
	</div>
</template>

<script>
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {},
		props: ["episodes"],
		data() {
			//这里存放数据
			return {};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			toReads(ji_no, index) {
				this.$parent.$parent.$parent.toRead(ji_no, index);
			}
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {},
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>

<style>
	.second-p {
		font-size: 20px;
		font-weight: bold;
	}
	.second-div1 {
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 30px;
	}

	.second-div1 p {
		font-size: 14px;
	}

	.second-div1 img {
		width: 12px;
		height: 6px;
		margin-left: 5px;
	}

	.second-img {
		width: 24px;
		height: 24px;
		margin-left: 10px;
	}

	.second-div-p {
		width: 33.333%;
		font-size: 14px;
		line-height: 24px;
		margin-bottom: 10px;
		display: flex;
		cursor: pointer;
	}

	.second-div-p i{
		background:url(../img/icon_cg.png) no-repeat center;
		display: inline-block;
		width: 2.3rem;
		height: 1.55rem;
		background-size: cover;
		margin-left: 0.5em;
	}

	.second-div {
		width: 100%;
		padding: 20px 0;
		display: flex;
		flex-wrap: wrap;
	}
	.Catalog-xxl-foot {
		height: 160px;
		box-sizing: border-box;
		border: 1px solid #cccccc;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.Catalog-xxl-foot-div-img {
		width: 44px;
		height: 44px;
		margin: 0 auto;
	}
	.Catalog-xxk-mydiv {
		display: flex;
		margin-top: 16px;
	}

	.Catalog-xxk-mydiv-p {
		font-size: 14px;
		color: #28a3b1;
	}

	.Catalog-xxk-mydiv-p1 {
		font-size: 14px;
	}

	.Catalog-mydiv2 {
		background-color: #f5f5f5;
	}
</style>



// WEBPACK FOOTER //
// src/components/publicmulu.vue